export type SortOrder = 1 | -1;

export function toSort(
  sortField: string | null | undefined,
  sortOrder: SortOrder,
  defaultField: string,
): string {
  const field = sortField && sortField.trim() !== "" ? sortField : defaultField;
  const dir = sortOrder === 1 ? "asc" : "desc";
  return `${field}:${dir}`;
}
